import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/reset.css'
import axios from 'axios'
import request from './requset'
import 'default-passive-events'

Vue.use(elementUI)

// Vue.use(axios)
Vue.prototype.$http = request



Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
